import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { OpenDialogDuplicateOfferComponent } from 'app/components/dialog/open-dialog-duplicate-offer/open-dialog-duplicate-offer.component';
import { OpenDialogGoToOfferSessionComponent } from 'app/components/dialog/open-dialog-go-to-offer-session/open-dialog-go-to-offer-session.component';
import { ClubDetails } from 'app/shared/models/class/club/club';
import { FilterPopUpTable } from 'app/shared/models/class/filterPopupTable/filterPopUpTable';
import { FullOffer } from 'app/shared/models/class/offer/offer';
import { OfferSession } from 'app/shared/models/class/session/session';
import { AuthService } from 'app/shared/services/auth/auth.service';
import { DataService } from 'app/shared/services/data/data.service';
import { FaiconService } from 'app/shared/services/faicon/faicon.service';
import { FilterpredicateService } from 'app/shared/services/filterPredicate/filterpredicate.service';
import { OfferService } from 'app/shared/services/offer/offer.service';
import { TooltipService } from 'app/shared/services/tooltip/tooltip.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-table-offers-club',
  templateUrl: './table-offers-club.component.html',
  styleUrls: ['./table-offers-club.component.scss']
})
export class TableOffersClubComponent extends SubscriptionBaseComponent implements OnInit {
  @Input() clubCode: string;
  @Input() club: ClubDetails;
  @Input() offers: FullOffer[];
  @Input() set valueSearch(value: string) {
    if (this.dataSource !== undefined) {
      this.applyFilter(value);
    }
  }

  @Output() offerPreviewUpdate = new EventEmitter<FullOffer>();
  @Output() onEdit = new EventEmitter<FullOffer>();
  @Output() switchToSession = new EventEmitter<FullOffer>();
  @Output() switchToFiles = new EventEmitter<FullOffer>();
  @Output() refreshOffers = new EventEmitter<boolean>();

  userConnected: any;
  displayedColumns: string[] = ['offerKey', 'offerName', 'price', 'backoffice', 'file', 'session', 'edit', 'duplicate', 'isActive', 'favoris', 'rating'];
  dataSource = new MatTableDataSource<FullOffer>();

  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  length = 0;
  pageSize = 25;
  pageSizeOptions: number[] = [5, 10, 25, 50];
  pageEvent: PageEvent;
  color: ThemePalette = 'primary';
  offer: FullOffer = null;
  valueFilter: FilterPopUpTable[];
  showTableSession = true;
  offerPreview: FullOffer;
  offerSelected: FullOffer;

  isLoading = false;

  constructor(
    private router: Router,
    private offerService: OfferService,
    private authService: AuthService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private filterPredicate: FilterpredicateService,
    private uiService: UiService,
    private tooltip: TooltipService,
    private route: ActivatedRoute,
    private faIconService: FaiconService,
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();

    this.initTable();

  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (changes.offers) this.offers = changes.offers.currentValue;
  }

  getFaIcon(faIcon: string): string {
    return this.faIconService.getFaIcon(faIcon);
  }

  applyFilter(filterValue: string): void {
    this.dataSource.filter = JSON.stringify(this.valueFilter)?.trim().toLowerCase();
  }

  private initTable(): void {
    this.isLoading = true;

    this.dataSource = new MatTableDataSource<FullOffer>(this.offers);

    this.length = this.offers?.length;
    this.isLoading = false;
  }

  editOffer(offer: FullOffer, tab?: string, action?: string): void {
    this.offerPreviewUpdate.emit(offer);
    this.onEdit.emit(offer);
  }

  isActivatedOrDeactivated(offer: FullOffer): void {

    const { isActive, picture, sessions, isExternalOffer, hasSession, offerKey } = offer;

    const newIsActive = !isActive;
    if (!isActive) {
      if (!picture) {
        this.uiService.showSnackbar(`L'offre n'a pas de photo.`);
        this.refreshOffers.next(true);
        return;
      }

      if (!sessions && !isExternalOffer && hasSession) {
        // this.uiService.showSnackbar(`L'offre n'a pas de session.`);
        const dialogRef = this.dialog.open(OpenDialogGoToOfferSessionComponent);

        dialogRef.afterClosed().subscribe({
          next: () => {
            this.dataService.actionFormOfferAdmin.next('edit');
            // this.tab.emit('session');

            this.editOffer(offer);
          }
        });
        return;
      }

      const check1 = picture && sessions?.length && !isExternalOffer && hasSession;
      const check2 = picture && !isExternalOffer && !hasSession;
      const check3 = picture && isExternalOffer;

      if (check1 || check2 || check3) {
        this.offerService.activateOrDeactivateOffer(offerKey, newIsActive).subscribe({
          next: () => {
            // TODO refresh ?
            //  this.getOffersByClub();
            this.refreshOffers.next(true);
          }
        });
      }
    } else {

      this.offerService.activateOrDeactivateOffer(offerKey, newIsActive).subscribe({
        next: () => {
          // TODO refresh ?
          //  this.getOffersByClub();
          this.refreshOffers.next(true);
        }
      });
    }

  }

  changePreview(offer: FullOffer): void {
    this.offerSelected = offer;
    this.offerPreviewUpdate.next(offer);
    this.cdr.detectChanges();
  }

  closePopUp(): void {
    this.dataService.resetPopUp();
  }

  duplicateOffer(offer: FullOffer): void {
    const dialogRef = this.dialog.open(OpenDialogDuplicateOfferComponent, {
      data: { offer }
    });

    dialogRef.afterClosed().subscribe({
      next: (res) => {
        if (res?.hasSession) {
          const dialogRef2 = this.dialog.open(OpenDialogGoToOfferSessionComponent);

          dialogRef2.afterClosed().subscribe({
            next: () => this.addSession(res)
          });

          return;
        } else {
          this.refreshOffers.next(true);
        }
      }
    })
  }

  getDataToCheckBox(column: string) {
    let data = this.dataSource.filteredData;

    if (this.valueFilter?.length && this.valueFilter[0].column === column) {
      data = this.dataSource.data;
    }

    return data;
  }

  addOfferToPriority(offer: FullOffer, isPriority): void {
    const newIsPriority = !isPriority;
    if (isPriority || (this.club.priorities < this.club.limitPriorities) || (this.club.priorities <= this.club.limitPriorities && isPriority)) {
      this.offerService.prioritizeOffer(offer.offerKey, newIsPriority).subscribe({
        next: () => {
          this.refreshOffers.next(true);
          offer.isPriority = newIsPriority;
        }
      });
    } else {
      this.uiService.showSnackbar(`Votre club ne peut avoir plus de ${this.club.limitPriorities} offres prioritaires`);
    }
  }

  getTooltip(tooltip: string): string {
    return this.tooltip.getTooltip(tooltip);
  }

  getRowSelected(offer: FullOffer): boolean {
    return true;
  }

  addSession(offer: FullOffer): void {
    this.switchToSession.next(offer);
  }

  copyString(offerKey: number): void {
    const link = `${environment.urlSite}home/offer?offerKey=${offerKey}`;
    if (navigator.clipboard) { navigator.clipboard.writeText(link); }
  }

  goToFilesOffer(offer: FullOffer): void {
    this.offerPreviewUpdate.next(offer);
    this.switchToFiles.next(offer);
  }


  getLengthSession(sessions: OfferSession[]): OfferSession[] {
    return sessions.filter(s => s.sessionStartDate.toString() !== '0001-01-01T00:00:00Z');
  }

  private getOfferByClubWithFilter(valueFilter: FilterPopUpTable[]): void {
    this.dataSource.filter = JSON.stringify(valueFilter)?.trim().toLowerCase();
    if (this.valueFilter?.length < 2) {
      this.filterPredicate.dataFilteredTable$.next(this.dataSource.filteredData);
    }
  }

  private initComponent(): void {
    this.dataService.valueFilterPopUpSelected$.next([]);
    this.filterPredicate.dataFilteredTable$.next([]);
    this.userConnected = this.authService.getDecodedToken();
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.filterPredicate = this.filterPredicate.getFilterPredicate(this.dataSource);
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataService.valueFilterPopUpSelected$.subscribe({
          next: valueFilter => {
            this.valueFilter = valueFilter;
            this.getOfferByClubWithFilter(valueFilter);
            this.cdr.detectChanges();
          }
        })
      );
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
